import React, { FC, useCallback, useEffect } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { Form, Modal } from 'src/common';
import TextArea from 'antd/lib/input/TextArea';
import { useGenerateResponse } from 'src/models/biddingGPT/hooks';

interface Props {
  onClose: () => void;
  onGenerate: (extraInstructions: string) => void;
}

export const AddInstructionsModal: FC<Props> = ({ onClose, onGenerate }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { settings, setSettings } = useGenerateResponse();

  const onFinish = useCallback(() => {
    onGenerate(form.getFieldValue('instructions'));
    onClose();
  }, [form, onClose, onGenerate]);

  useEffect(
    () =>
      form.setFieldsValue({
        instructions: settings?.extraInstructions?.length ? settings?.extraInstructions[0] : ''
      }),
    [form, settings]
  );

  return (
    <Modal
      title={t('BiddingTool.addExtraInstructions')}
      visible
      onCancel={onClose}
      onOk={onFinish}
      okText={t('BiddingTool.biddingGPTGenerateResponse')}
      okButtonProps={{
        className: styles.okButton
      }}
      cancelButtonProps={{
        className: styles.cancelButton
      }}
      className={styles.modal}
      maskClosable={false}
    >
      <Form form={form}>
        <div className={styles.unit}>
          <Form.Item name="instructions" className={styles.formItem}>
            <TextArea
              name="instructions"
              autoSize={{ minRows: 2 }}
              placeholder={t('BiddingTool.addExtraInstructions')}
              autoFocus
              onChange={e => setSettings({ ...settings, extraInstructions: [e.target.value] })}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddInstructionsModal;
